module.exports = __webpack_public_path__ + "static/media/86.bcb95509.png";